import { render, staticRenderFns } from "./finance.vue?vue&type=template&id=227b0ce3&scoped=true&"
import script from "./finance.vue?vue&type=script&lang=js&"
export * from "./finance.vue?vue&type=script&lang=js&"
import style0 from "./finance.vue?vue&type=style&index=0&lang=css&"
import style1 from "../statistics/css/finance.css?vue&type=style&index=1&id=227b0ce3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227b0ce3",
  null
  
)

export default component.exports